import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { authdApiRequest } from '../utils/api';
import LoadingScreen from '../components/LoadingScreen';

function SnapshotView() {
  const { snapshotId } = useParams();
  const [snapshot, setSnapshot] = useState(null);
  const [statusData, setStatusData] = useState(null);

  useEffect(() => {
    const fetchSnapshot = async () => {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys/${snapshotId}/preformatted`);
        const data = await response.json();
        setSnapshot(data);
      } catch (error) {
        console.error('Error fetching snapshot:', error);
      }
    };

    const fetchSnapshotStatus = async () => {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys/${snapshotId}/status`);
        const data = await response.json();
        setStatusData(data);
      } catch (error) {
        console.error('Error fetching snapshot status:', error);
      }
    };

    fetchSnapshot();
    fetchSnapshotStatus();
  }, [snapshotId]);

  useEffect(() => {
    if (snapshot) {
      document.title = `${snapshot.title || 'Snapshot'} Status - DevWing`;
    }
  }, [snapshot]);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (!snapshot || !statusData) {
    return <LoadingScreen />;
  }

  return (
    <Layout>
      <h1 className="text-3xl font-bold mb-8 text-center">{formatDate(snapshot.endDate)} Snapshot ({snapshot.title})</h1>
      
      <div className="mb-4 p-6 bg-neutral-900 rounded-lg border border-neutral-700">
        <h2 className="text-2xl font-bold text-center">Status: {statusData.status}</h2>
      </div>
      <div className="mb-8 p-6 bg-neutral-900 rounded-lg border border-neutral-700">
        <div className="flex justify-around mb-8">
          <div className="text-center">
            <h3 className="text-lg font-semibold">Total Users</h3>
            <p className="text-xl">{statusData.totalUsers}</p>
          </div>
          <div className="text-center">
            <h3 className="text-lg font-semibold">Total Replied</h3>
            <p className="text-xl">{statusData.totalReplied}</p>
          </div>
          <div className="text-center">
            <h3 className="text-lg font-semibold">Total Not Replied</h3>
            <p className="text-xl">{statusData.totalNotReplied}</p>
          </div>
        </div>
        <div className="flex justify-around">
          <div className="w-1/2 pr-4 text-center">
            <h3 className="text-lg font-semibold mb-2">Users Who Replied</h3>
            <ul className="list-disc pl-5 list-none">
              {statusData.usersWhoReplied.map((user) => (
                <li key={user.id} className="text-white">{user.name}</li>
              ))}
            </ul>
          </div>
          <div className="w-1/2 pl-4 text-center">
            <h3 className="text-lg font-semibold mb-2">Users Who Did Not Reply</h3>
            <ul className="list-disc pl-5 list-none">
              {statusData.usersWhoDidNotReply.map((user) => (
                <li key={user.id} className="text-white">{user.name}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default SnapshotView;
